import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X, Check } from "lucide-react";

const STORAGE_KEY = "itsp_cookie_consent_v1";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) {
        const t = setTimeout(() => setVisible(true), 700);
        return () => clearTimeout(t);
      }
    } catch {
      /* localStorage blocked */
    }
  }, []);

  const handleSave = (choice) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice, decided_at: new Date().toISOString() })
      );
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      role="dialog"
      aria-live="polite"
      aria-label="Cookie-Einstellungen"
      className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-6 md:bottom-6 md:left-auto md:right-6 md:max-w-md z-50 animate-fade-up"
    >
      <div className="bg-white border border-line shadow-glow p-6 sm:p-7">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 bg-soft border border-line flex items-center justify-center flex-shrink-0 text-primary">
            <Cookie size={20} aria-hidden="true" />
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="font-display font-bold text-lg text-ink">Cookies & Datenschutz</h2>
            <p className="mt-2 text-sm text-muted leading-relaxed">
              Wir verwenden ausschließlich technisch notwendige Cookies, um den Admin-Bereich
              und Ihre Sprachauswahl zu speichern. Es findet <strong className="text-ink">kein</strong> Tracking
              und keine Weitergabe an Dritte statt.{" "}
              <Link to="/datenschutz" className="text-primary underline hover:text-primary-hover">
                Mehr in der Datenschutzerklärung
              </Link>
              .
            </p>
            <div className="mt-5 flex flex-col sm:flex-row gap-2">
              <button
                onClick={() => handleSave("accepted")}
                data-testid="cookie-accept"
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-primary text-white text-sm font-medium hover:bg-primary-hover transition-colors flex-1"
              >
                <Check size={15} /> Einverstanden
              </button>
              <button
                onClick={() => handleSave("declined")}
                data-testid="cookie-decline"
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5 border border-line text-muted hover:text-ink hover:border-primary text-sm font-medium transition-colors flex-1"
              >
                <X size={15} /> Nur notwendige
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
